<template>
  <b-modal
    modal-class="client-form-modal"
    body-class="bg-extra-light-gray p-0"
    footer-class="bg-extra-light-gray"
    v-model="editorShown"
    :title="''"
    size="md-lg"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">
          Submit charges
        </h5>
        <div class="d-flex align-items-center">
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            @click="$emit('onModify')"
          >
            ×
          </button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="text-left mt-1 mr-2"></div>
        <div class="text-right mt-1 mr-2">
          <b-button @click="$emit('onModify')" variant="secondary"
            >Cancel</b-button
          >
          <b-button
            v-if="billings"
            class="ml-2"
            variant="success"
            @click="submitForBilling"
            >Submit for billing</b-button
          >
        </div>
      </div>
    </template>

    <div class="position-relative">
      <div class="d-flex">
        <div class="client-form-container position-relative w-100 bg-white">
          <div class="section-body">
            <b-row>
              <b-col class="modal-col">
                <h6 class="mb-0 font-weight-bold">
                  Are you sure that you want to submit the following charges for
                  billing?
                </h6>
              </b-col>
            </b-row>
            <div class="mx-4 my-2">
              <b-row>
                <b-col>
                  <h6>
                    Patient
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    Date
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    Provider
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    Service code(s)
                  </h6>
                </b-col>
              </b-row>
              <b-row v-for="billing in billings" :key="billing.id">
                <b-col cols="12">
                  <hr class="row-separator" />
                </b-col>
                <b-col>
                  <h6>
                    {{ billing.patient }}
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    {{ formatDate(billing.date) }}
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    {{ billing.provider }}
                  </h6>
                </b-col>
                <b-col>
                  <h6>
                    {{
                      billing.services
                        ? billing.services.map(x => x.code).join(", ")
                        : ""
                    }}
                  </h6>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import { formatDate } from "../../../helpers/date";
import { validateEncountersForSubmit } from "../../../helpers/encounter";
import billingServer from "../../../server/billing";

export default {
  name: "BillingMassSubmitModal",
  components: {},
  props: ["billings"],
  data() {
    return {};
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    formatDate,
    submitForBilling() {
      this.$dialog
        .confirm(
          { title: "Are you sure you want to submit these charges?" },
          { view: "confirm" }
        )
        .then(async () => {
          const errors = validateEncountersForSubmit(this.billings);
          if (errors.length) {
            this.showError({
              message: "Errors: \r\n" + errors.join("\r\n"),
              multiline: true
            });
            return;
          }
          await billingServer
            .submit(this.billings.map(x => x.id))
            .then(() => this.showAlertSuccess());
          this.$emit("onModify");
        })
        .catch(function() {});
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.section-body {
  min-height: 70px;
}
.modal-col {
  margin: 20px;
}
.badge-fixed-size {
  min-width: 101px;
}
.add-button {
  max-height: 35px;
  margin: 30px 10px;
}
.row-separator {
  margin-top: 5px;
}
</style>
